import { Storage } from '@/enums/storage.enum';
import { tryParseInt } from '@/utils/number';

/**
 * Pobiera identyfikator profilu z sesji
 *
 * @export
 * @returns
 */
export function getProfileId() {
  return tryParseInt(localStorage.getItem(Storage.PROFILE_ID) as string);
}
